module.exports = "/fonts/ElevanceSans-Medium.e4a581c437305526ee794809dee5f95e.woff2";